export const SET_LIVE_TALKS = 'SET_LIVE_TALKS';
export const SET_LIVE_FEEDINGS = 'SET_LIVE_FEEDINGS';
export const SET_LIVE_STREAMS = 'SET_LIVE_STREAMS';
export const SET_ALL_SCHEDULES = 'SET_ALL_SCHEDULES';
